import { components } from '@miro-site/components-twig';
var Slider3 = components.Slider3,
    Feature2 = components.Feature2;
var slider1 = {
  tabs: [{
    title: 'Meetings & Workshops',
    description: 'Run productive, engaging online remote meetings and workshops with your team.',
    image: {
      src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/slider/meetings_and_workshops.png?001',
      alt: 'Meetings & Workshops'
    }
  }, {
    title: 'Ideation & Brainstorming',
    description: 'Build and develop ideas with distributed teams as if you were in the same room, anywhere, anytime.',
    image: {
      src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/slider/ideation_brainstorming.png?001',
      alt: 'Ideation & Brainstorming'
    }
  }, {
    title: 'Research & Design',
    description: 'Co-create and align with cross-functional stakeholders on a collaborative, online whiteboard.',
    image: {
      src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/slider/research_design.png?001',
      alt: 'Research & Design'
    }
  }, {
    title: 'Agile Workflows',
    description: 'Supercharge your agile process with collaborative retrospectives, sprint planning, and huddle boards.',
    image: {
      src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/slider/agile_workflows.png?001',
      alt: 'Agile Workflows'
    }
  }, {
    title: 'Strategy & Planning',
    description: 'Stay on the pulse of distributed projects with an online whiteboard to plan, coordinate and discuss.',
    image: {
      src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/slider/strategy_planning.png?002',
      alt: 'Strategy & Planning'
    }
  }, {
    title: 'Mapping & Diagramming',
    description: 'Explain complex processes and systems with visual mapping and diagramming.',
    image: {
      src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/slider/mapping_diagramming.png?002',
      alt: 'Mapping & Diagramming'
    }
  }],
  video: {
    id: 'x835ey7j3o',
    description: 'Watch product demo'
  }
};
var slider3 = {
  headline: {
    text: '30M+ users trust Miro worldwide',
    tag: 'h2',
    size: 'small'
  },
  items: [{
    image: {
      src: 'https://static-website.miro.com/static/images/components/sections/slider/pivotal.svg',
      alt: 'Pivotal'
    }
  }, {
    image: {
      src: 'https://static-website.miro.com/static/images/components/sections/slider/cisco.svg',
      alt: 'Cisco'
    }
  }, {
    image: {
      src: 'https://static-website.miro.com/static/images/components/sections/slider/dell.svg',
      alt: 'DELL'
    }
  }, {
    image: {
      src: 'https://static-website.miro.com/static/images/components/sections/slider/deloitte.svg',
      alt: 'Deloitte'
    }
  }, {
    image: {
      src: 'https://static-website.miro.com/static/images/logos/partners/trans_union.svg',
      alt: 'TransUnion'
    }
  }, {
    image: {
      src: 'https://static-website.miro.com/static/images/logos/partners/okta.svg',
      alt: 'okta'
    }
  }, {
    image: {
      src: 'https://static-website.miro.com/static/images/logos/partners/liberty_mutual.svg',
      alt: 'Liberty Mutual'
    }
  }, {
    image: {
      src: 'https://static-website.miro.com/static/images/logos/partners/kaiser_permanente.svg',
      alt: 'kaiser permanente'
    }
  }, {
    image: {
      src: 'https://static-website.miro.com/static/images/logos/partners/hewlett.svg',
      alt: 'Hewlett Packard Enterprise'
    }
  }]
};
var card_section = {
  offset: {
    top: 40,
    bottom: 0
  },
  grid: {
    columns: 3
  },
  headline: {
    text: 'Take advantage of\nour remote work resources\n',
    tag: 'h3',
    size: 'small'
  },
  items: [{
    background: 'yellow',
    content: {
      html: 'The Ultimate Guide to\nRemote Work\n',
      size: 'small',
      color: 'dark'
    },
    icon: {
      letter: 'i',
      color: 'yellow'
    },
    link: {
      text: 'Read the guide',
      href: '/guides/remote-work/',
      id: 'read-guide',
      place: 'main-page-card-section',
      size: 'small',
      arrow: 'true',
      color: 'dark'
    }
  }, {
    background: 'yellow',
    content: {
      html: 'Meetings & workshops FAQ\n',
      size: 'small'
    },
    icon: {
      letter: 'r',
      color: 'yellow'
    },
    link: {
      text: 'Visit Help Center',
      href: 'https://help.miro.com/hc/en-us/articles/360012753200-Miro-for-Workshops-and-Meetings',
      id: 'visit-help-center',
      place: 'main-page-card-section',
      size: 'small',
      arrow: 'true',
      color: 'dark'
    }
  }, {
    background: 'yellow',
    content: {
      html: 'How-to webinars\n',
      size: 'small'
    },
    icon: {
      letter: 'm',
      color: 'yellow'
    },
    link: {
      text: 'Register now',
      href: 'https://go.miro.com/en/webinars',
      id: 'register-now',
      place: 'main-page-card-section',
      size: 'small',
      arrow: 'true',
      color: 'dark'
    }
  }]
};
var confidence1 = {
  data: {
    html: 'Scale\ncollaboration\nwith confidence\n',
    description: 'With enterprise-ready security and advanced administration controls, deploy Miro company-wide with ease. A dedicated Customer Success and Account Manager will partner with you every step of the way to ensure your team’s success and train you on best practices we’ve picked up from other enterprise customers.',
    link: {
      text: 'Learn more about Miro Enterprise',
      href: '/enterprise/'
    }
  }
};
var feature2 = {
  html: 'Everything\nyou need\nto\ndo better work\n',
  block_1: {
    html: 'Real-time\n& asynchronous collab<span class="com-sec-feature-2__top-left-section-title--white-mobile">orati</span><span class="com-sec-feature-2__top-left-section-title--white">on</span>\n',
    content: 'Whether your teams are colocated, distributed, or fully remote, Miro provides an engaging, intuitive, in-person collaboration experience with multiple options for real-time or asynchronous teamwork on an online whiteboard.',
    image_1: {
      src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/future_2/top-left-section-bg-desktop.svg',
      alt: ''
    },
    image_2: {
      src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/future_2/top-left-section-bg-mobile.svg',
      alt: ''
    }
  },
  block_2: {
    html: 'Infinite canvas\n',
    content: 'Miro’s infinitely zoomable canvas and web whiteboard enables you to work the way you want to. Unleash your creativity, plan projects from all angles, and create centralized hubs of information to keep everyone in the loop. See the big picture and the details.',
    image_1: {
      src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/future_2/top-right-section-bg.svg',
      alt: ''
    },
    image_2: {
      src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/future_2/top-right-section-bg-mobile.svg',
      alt: ''
    }
  },
  block_3: {
    html: 'Integrations\nfor your workflow\n',
    content_html: 'Our deep integrations with today’s most popular and trusted tools like Dropbox, Box, Google Suite, JIRA, Slack, and Sketch tie\nin seamlessly to your existing workflow\nwithin a scalable online whiteboard.\n',
    link: {
      text: 'All apps & integrations',
      href: '/marketplace/'
    },
    image_1: {
      src: 'https://static-website.miro.com/static/images/page/mr-index/localization/en/future_2/bottom-left-section-bg-mobile.svg',
      alt: ''
    }
  },
  block_4: {
    html: 'Enterprise-grade security\n',
    content_html: 'Rest easy knowing privacy and security\nhas been built into the fabric of the Miro’s online whiteboard platform, including\nthe option to add advanced security\nand compliance controls.\n',
    link: {
      text: 'Check our Enterprise plan',
      href: '/enterprise/'
    }
  }
};
var review2 = {
  data: {
    html: 'Calling all modern-day\npioneers\n',
    block_1: {
      html: 'Design\n',
      content: '“When the pandemic hit, those of us who thrive on in-person collaboration were worried that our creativity and productivity would suffer. Miro was the perfect tool to help us with collaboration, whiteboarding, and retrospectives while remote.”',
      image: {
        mobile: 'https://static-website.miro.com/static/images/page/mr-index/index-experiment/kevin-yang-m.png',
        desktop: 'https://static-website.miro.com/static/images/page/mr-index/index-experiment/roxanne_mustafa.png'
      },
      logo: {
        src: 'https://static-website.miro.com/static/images/page/mr-index/index-experiment/vmware.svg',
        alt: 'Vmware'
      },
      author_html: '<strong>Roxanne Mustafa</strong>Design Team Lead at VMware'
    },
    block_2: {
      html: 'User Experience\n',
      content: '“It is the thread that ties all parts of a project together.”',
      logo: {
        src: 'https://static-website.miro.com/static/images/page/mr-index/index-experiment/guidewire.svg',
        alt: 'GuideWire'
      },
      author_html: '<strong>Dave Legegett</strong>Sr. UX Designer at Guidewire\n'
    },
    block_3: {
      html: 'Product\n',
      content: '“Miro is a great way to get everybody in a single location and share your designs and your projects seamlessly.”',
      logo: {
        src: 'https://static-website.miro.com/static/images/page/mr-index/index-experiment/zenddesk.svg',
        alt: 'Zenddesk'
      },
      author_html: '<strong>Peter Travis</strong>Product Designer at Zendesk\n'
    },
    block_4: {
      html: 'Strategy and Design\n',
      content_html: '“As we used Miro we moved from skepticism to belief to innovation, and now we have a tool that’s at the core of what we do and will continue to extend into the future.”\n',
      image: {
        desktop: 'https://static-website.miro.com/static/images/page/mr-index/index-experiment/laura_baird.png'
      },
      logo: {
        src: 'https://static-website.miro.com/static/images/page/mr-index/index-experiment/frog.svg',
        alt: 'Frog'
      },
      author_html: '<strong>Laura Baird</strong>Associate Design Director at frog\n'
    }
  }
};
var action2 = {
  section: {
    header: 'Join over 30 million users\n',
    subtitle: 'Start for free — upgrade anytime.\n',
    button: {
      title: 'Sign up free',
      link: '/app/',
      track: {
        id: 'sign-up-free-btn',
        place: 'Collaboration without constraints a test'
      }
    },
    button_auth: {
      text: 'Start a whiteboard',
      href: '/app/',
      track: {
        id: 'sign-up-free-btn',
        place: 'Collaboration without constraints a test'
      }
    }
  }
};
export { slider3, slider1, card_section, confidence1, feature2, review2, action2 };